import type { HTMLAttributes } from 'react';
import { cx } from '@/lib/cx';
import styles from './Tag.module.css';

export interface TagProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: 'neutral' | 'accent';
}

/** Small monospace chip used for technologies, sectors and engagement types. */
export function Tag({ tone = 'neutral', className, ...rest }: TagProps) {
  return <span className={cx(styles.tag, tone === 'accent' && styles.accent, className)} {...rest} />;
}
